import '../../../App.css'
import React, { useContext, useState, useEffect } from "react";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { AdminContext } from '../../../context/AdminContext';
import { StyleContext } from '../../../context/StyleContext';
import UploadImagem from '../../../components/UploadImagem';

function ModalEditarLayout({ closeModal }) {
    const { LayoutAtual, EditarLayout, setLayoutAtual, obterEmpresas, Empresas } = useContext(AdminContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [empresaKey, setEmpresaKey] = useState("")

    const handleChange = (event) => {
        setLayoutAtual({ ...LayoutAtual, [event.target.name]: event.target.value })
    }

    const handleFile = async (event) => {
        const file = event.target.files[0]
        const file64 = await convertBase64(file)
        setLayoutAtual({ ...LayoutAtual, [event.target.name]: file64 })
    }

    const handleImageChange = ({ name, base64, fileName }) => {
        setLayoutAtual(prev => ({
            ...prev,
            [name]: base64
        }));
    };

    const handleRemoveImage = (name) => {
        setLayoutAtual(prev => ({
            ...prev,
            [name]: ""
        }));
    };

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result)
            }
            fileReader.onerror = (error) => {
                reject(error)
            }
        })
    }

    useEffect(() => {
        obterEmpresas()
    }, [])

    return (
        <div className="modal-criar-demanda">
            <div className="modal-criar-demanda-interno">
                <div className="header-modal-criar-demanda">
                    <div>
                        <h1 className="h1-modal">Editar layout</h1>
                    </div>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={EditarLayout}>
                    <div className="modal-content-criar-demanda">
                        <Row style={{ paddingTop: 20 }}>

                            <Row>
                                <Col lg={6}>
                                    <UploadImagem
                                        label="Logo do login"
                                        name="logoLogin"
                                        value={LayoutAtual.logoLogin}
                                        url={LayoutAtual.logoLogin}
                                        onChange={handleImageChange}
                                        onRemove={handleRemoveImage}
                                    />
                                </Col>

                                <Col lg={6}>
                                    <UploadImagem
                                        label="Logo branca"
                                        name="logoNavbar"
                                        value={LayoutAtual.logoNavbar}
                                        url={LayoutAtual.logoNavbar}
                                        onChange={handleImageChange}
                                        onRemove={handleRemoveImage}
                                    />
                                </Col>

                                <Col lg={6}>
                                    <UploadImagem
                                        label="Logo menu"
                                        name="logoMenu"
                                        value={LayoutAtual.logoMenu}
                                        url={LayoutAtual.logoMenu}
                                        onChange={handleImageChange}
                                        onRemove={handleRemoveImage}
                                    />
                                </Col>

                                <Col lg={6}>
                                    <UploadImagem
                                        label="Logo background"
                                        name="logoBackground"
                                        value={LayoutAtual.logoBackground}
                                        url={LayoutAtual.logoBackground}
                                        onChange={handleImageChange}
                                        onRemove={handleRemoveImage}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col >
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cor primaria</Form.Label>
                                        <Form.Control type="color" defaultValue={LayoutAtual.corPrimaria} onBlur={handleChange} name="corPrimaria" />
                                    </Form.Group>
                                </Col>
                                <Col >
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cor secundária</Form.Label>
                                        <Form.Control type="color" defaultValue={LayoutAtual.corSecundaria} onBlur={handleChange} name="corSecundaria" />
                                    </Form.Group>
                                </Col>
                                <Col >
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cor terciária</Form.Label>
                                        <Form.Control type="color" defaultValue={LayoutAtual.corTerciaria} name="corTerciaria" onBlur={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Url</Form.Label>
                                        <Form.Control defaultValue={LayoutAtual.url} onChange={handleChange} name="url" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Empresa associada</Form.Label>
                                        <Form.Select aria-label="Default select example" value={LayoutAtual?.empresaKey} onChange={handleChange} name="empresaKey">
                                            <option value="">Selecione</option>
                                            {Empresas && Empresas.sort((a, b) => a?.fantasia?.localeCompare(b?.fantasia))?.map((item) => {
                                                return (
                                                    <option key={item.id} value={item?.key} selected={item?.key == LayoutAtual?.empresaKey ? true : false}>
                                                        {item.fantasia}
                                                    </option>
                                                )
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => closeModal(false)}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar} >Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalEditarLayout